module.exports = __webpack_public_path__ + "media/images/pvp@2x-1501fe33cd590d386fd3c19bcb6e9840.webp";